// AUTO-GENERATED by scripts/write-version.js — do not edit.
export const buildVersion = '0.1.0.04b988a';
